import Image from 'next/image'
import { cn } from '@eversports/klimt-design-components/tailwind/utils'

import {
  FILLED_STAR_ICON,
  EMPTY_STAR_ICON,
  HALF_STAR_ICON,
  QUARTER_STAR_ICON,
  THREE_QUARTER_STAR_ICON,
} from '../../App.icons'

export enum StarVariant {
  FILLED = 'FILLED',
  EMPTY = 'EMPTY',
  HALF = 'HALF',
  QUARTER = 'QUARTER',
  THREE_QUARTER = 'THREE_QUARTER',
}

const StarIconMapping: { [key in StarVariant]: string } = {
  [StarVariant.FILLED]: FILLED_STAR_ICON,
  [StarVariant.EMPTY]: EMPTY_STAR_ICON,
  [StarVariant.HALF]: HALF_STAR_ICON,
  [StarVariant.QUARTER]: QUARTER_STAR_ICON,
  [StarVariant.THREE_QUARTER]: THREE_QUARTER_STAR_ICON,
}

interface StarProps {
  variant: StarVariant
  size: 'regular' | 'small'
}

const Star = ({ variant, size }: StarProps) => (
  <Image src={StarIconMapping[variant]} alt="" className={cn(size === 'small' ? 'size-[8px]' : 'size-auto')} />
)

export default Star
